// src/hooks/useConfirmDialog.js

import { useState, useCallback } from 'react';

const useConfirmDialog = () => {
  const [dialogState, setDialogState] = useState({
    show: false,
    title: '',
    message: '',
    confirmText: '',
    cancelText: '',
    variant: 'danger',
    icon: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const showConfirm = useCallback(({
    title,
    message,
    confirmText,
    cancelText,
    variant = 'danger',
    icon = null,
    onConfirm = () => {},
  }) => {
    return new Promise((resolve) => {
      setDialogState({
        show: true,
        title,
        message,
        confirmText,
        cancelText,
        variant,
        icon,
        onConfirm: () => {
          onConfirm();
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  }, []);

  const hideConfirm = useCallback(() => {
    setDialogState(prev => ({
      ...prev,
      show: false,
    }));
  }, []);

  const handleCancel = useCallback(() => {
    hideConfirm();
    // Return false for promise resolution if needed
    return Promise.resolve(false);
  }, [hideConfirm]);

  return {
    dialogState,
    showConfirm,
    hideConfirm,
    handleCancel,
  };
};

export default useConfirmDialog;
